<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="22" viewBox="0 0 17 22" fill="none" :class="customClass " aria-hidden="true"><path fill="#969696" d="M1.543.999A1 1 0 0 0 0 1.839v18.323a1 1 0 0 0 1.543.84l14.16-9.162a1 1 0 0 0 0-1.68L1.543 1Z"/></svg>
</template>
<script>
export default {
  data: () => ({
  }),
  props: {
    customClass: {
      type: String,
      required: false
    },
  },
  mounted() {},
  computed: {}
}
</script>
